import { StatusPill } from '../../../../models/shared/status-pill';
import { EmployerContactSubmissionData } from '../../../../models/submissions/employer-submissions/submission-bodies/update-contacts/employer-contact-submission-data';
import { SubmissionInfoItem } from '../../../../models/shared/submission-info-item';

export class EmployerContactSubmissionDetailsChange {
  public contactName: string;
  public statusPill: StatusPill;
  public primaryContact: boolean;
  public previous: SubmissionInfoItem[];
  public new: SubmissionInfoItem[];

  constructor(
    contact: EmployerContactSubmissionData,
    previous: SubmissionInfoItem[] = [],
    newChanges: SubmissionInfoItem[] = []
  ) {
    this.contactName = contact.firstName + ' ' + contact.lastName;
    this.primaryContact = contact.primaryContact;
    this.statusPill = contact.primaryContact ? this.buildPrimaryStatusPill() : this.buildAdditionalStatusPill();
    this.previous = previous;
    this.new = newChanges;
  }

  private buildPrimaryStatusPill(): StatusPill {
    return new StatusPill(0, $localize`Primary`, '#104255', '#DCEBFA', '#104255');
  }

  private buildAdditionalStatusPill(): StatusPill {
    return new StatusPill(0, $localize`Additional`, '#5E0F5E', '#FADCFA', '#5E0F5E');
  }
}
